import React from 'react'
import { Link } from 'react-router-dom'


import planetImg from './imgs/planet.png'
import './Nav.css'



export default function Nav() {
    return(
        <nav className="nav_div">

            <Link to='/' className='link_nav'>

                <p className="titleNav">FER  PR<img src={planetImg} alt="#" className='planetLogo' />JECTS</p>

            </Link>
        </nav>
    )
}